import { lazy } from 'react';

const CartSettingsPage = lazy(() => import('./CartSettingsPage'));

const CartSettingsAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/frontend-settings/cart-settings',
			element: <CartSettingsPage />
		}
	]
};

export default CartSettingsAppConfig;
